<template>
  <el-dialog
    :title="form.id ? '编辑分类':'新建分类'"
    :visible.sync="dialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >

    <el-form :model="form" :rules="rule" ref="form">
      <el-form-item label="分类名称" :label-width="formLabelWidth" prop='name'>
        <el-input v-model="form.name" autocomplete="off" placeholder="请输入分类名称"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateFaceClassData,addFaceClassData } from '@/api/api'

export default {
  components:{
  },
  props: {
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      formLabelWidth:'80px',
      form:{},
      rule: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          {
            max: 200,
            message: "最长200个字符",
            trigger: "blur",
          }
        ]
      },
    };
  },
  methods:{
    setOpacity(flg){
      this.dialogVisible = flg;
    },
    handleClose(){
      this.dialogVisible = false;
    },
    sure(){
      if( this.form.id ){
        updateFaceClassData({
          id:this.form.id,
          name:this.form.name,
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success('更新成功');
            this.$emit('success');
            this.handleClose()
            this.form = {}
          } else {
            this.$message.error(message);
          }
        })
      }else{
        addFaceClassData(this.form).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success('新增成功');
            this.$emit('success');
            this.handleClose()
            this.form = {}
          } else {
            this.$message.error(message);
          }
        })
      }
    }
  },
  watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        // this.dialogVisible = newValue ?? true
        this.form = newValue ? JSON.parse(JSON.stringify(newValue)) : {}
      },
    },
  },
};
</script>

<style lang='scss'></style>
